import useTranslation from "next-translate/useTranslation";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import MolhamButton from "./MolhamButton";

type Props = {
  shareUrl: string;
  copied: boolean;
  setCopied: (copied: boolean) => void;
};

const CopyLinkInput = ({ shareUrl, copied, setCopied }: Props) => {
  const onBtnClick = () => {
    toast("You copied the link");
  };

  const onCopy = () => setCopied(true);

  const { t } = useTranslation("common");

  return (
    <div className="input-group my-3 pt-1 justify-content-center">
      <input
        readOnly
        className="form-control p-2"
        type="text"
        placeholder="Button on the right"
        defaultValue={shareUrl}
        onFocus={(e) => e.target.select()}
        style={{
          direction: "ltr",
          height: 46,
          flex: "unset",
          width: "unset",
          minWidth: "unset",
        }}
      />

      <CopyToClipboard text={shareUrl} onCopy={onCopy}>
        <MolhamButton
          id="copy-link-btn"
          label={copied ? t(`copied`) : t(`copy`)}
          startIcon="fe-copy"
          onClick={onBtnClick}
          type="button"
        />
      </CopyToClipboard>
    </div>
  );
};

export default CopyLinkInput;
